import React from 'react'
import ColumnsRowsGuidesDialog, {
  type ColumnsRowsSettings,
  type GuideUnit,
} from '@/components/app/layout/columns-rows-guides-dialog'
import PreferencesDialog, {
  type PreferencesValues,
} from '@/components/app/layout/preferences-dialog'
import type { MenubarInputs } from '../types/menubar-inputs'

type MenubarDialogsProps = {
  isGuidesDialogOpen: boolean
  onGuidesDialogOpenChange: (open: boolean) => void
  rulerUnit: GuideUnit
  guideSettings: ColumnsRowsSettings
  defaultGuttersLinked: boolean
  pageInnerWidth: number
  pageInnerHeight: number
  onSetColumnsRows: MenubarInputs['onSetColumnsRows']
  isPreferencesDialogOpen: boolean
  onPreferencesDialogOpenChange: (open: boolean) => void
  preferencesValues: PreferencesValues
  onPreferencesSave: (next: PreferencesValues) => void
}

/** The two dialogs the menu opens: View → Set Columns & Rows Guides and File → Preferences. */
export const MenubarDialogs: React.FC<MenubarDialogsProps> = ({
  isGuidesDialogOpen,
  onGuidesDialogOpenChange,
  rulerUnit,
  guideSettings,
  defaultGuttersLinked,
  pageInnerWidth,
  pageInnerHeight,
  onSetColumnsRows,
  isPreferencesDialogOpen,
  onPreferencesDialogOpenChange,
  preferencesValues,
  onPreferencesSave,
}) => {
  return (
    <>
      <ColumnsRowsGuidesDialog
        open={isGuidesDialogOpen}
        onOpenChange={onGuidesDialogOpenChange}
        unit={rulerUnit}
        settings={guideSettings}
        defaultGuttersLinked={defaultGuttersLinked}
        pageInnerWidth={pageInnerWidth}
        pageInnerHeight={pageInnerHeight}
        // Expression-bodied on purpose: home.tsx's handler is async and the dialog awaits the
        // returned promise to close on success or show its error line on failure.
        onSettingsChange={(next) => onSetColumnsRows?.(next)}
      />
      <PreferencesDialog
        open={isPreferencesDialogOpen}
        onOpenChange={onPreferencesDialogOpenChange}
        values={preferencesValues}
        onSave={onPreferencesSave}
      />
    </>
  )
}
